module.exports = __webpack_public_path__ + "static/media/banner_compendioC4.360d49ed.jpg";